export type SheetType = 'worksheet' | 'unit_test' | 'annual_exam'

export const SHEET_TYPES: ReadonlyArray<{
  value: SheetType
  label: string
  plural: string
}> = [
  { value: 'worksheet', label: 'Worksheet', plural: 'Worksheets' },
  { value: 'unit_test', label: 'Unit Test', plural: 'Unit Tests' },
  { value: 'annual_exam', label: 'Exam Paper', plural: 'Exam Papers' },
]

export function sheetTypeLabel(value: SheetType) {
  return SHEET_TYPES.find((item) => item.value === value)?.label ?? 'Worksheet'
}

export function isExamSheet(value: SheetType) {
  return value !== 'worksheet'
}
